import { Component, ElementRef, OnInit } from "@angular/core";
import { Router, NavigationEnd, RouterOutlet } from "@angular/router";
import { Claims } from "src/app/_models/common/claims";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { BuildDetailsService } from "src/app/build-details.service";
import { CommonModule } from "@angular/common";
import { TopbarComponent } from "../topbar/topbar.component";
import { SidebarComponent } from "../sidebar/sidebar.component";
import { RightsidebarComponent } from "../rightsidebar/rightsidebar.component";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-vertical",
    templateUrl: "./vertical.component.html",
    standalone: true,
    imports: [CommonModule, TopbarComponent, SidebarComponent, RightsidebarComponent, RouterOutlet]
})

/**
 * Vertical Component
 */
export class VerticalComponent implements OnInit {
  claims: Claims;
  isCondensed = false;
  isScanInProgress = false;
  isImportInProgress = false;
  constructor(
    private router: Router,
    private claimsService: ClaimsService,
    private host: ElementRef<HTMLElement>,
    private buildDetailsService: BuildDetailsService,
  ) {
    this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
    });
    this.claimsService.currentIsCreditCardScanInProgress.subscribe((v: boolean) => {
      this.isScanInProgress = v;
    });
    this.claimsService.currentIsImportSubmitting.subscribe((v: boolean) => {
      this.isImportInProgress = v;
    });
    router.events.forEach((event) => {
      if (window.screen.width <= 768) {
        if (event instanceof NavigationEnd) {
          document.body.classList.remove("sidebar-enable");
        }
      }
    });
  }

  ngOnInit(): void {
    //this.host.nativeElement.style.setProperty('$sidebar-width', '0');
    //document.body.getElementsByClassName('main-content')[0].cl;
    document.body.removeAttribute("data-layout");

    if (this.claims.orgRoleId != 3) {
      document.body.setAttribute("data-sidebar-size", "smc");
    }
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.claimsService.onToggleMobileMenu(this.claims.IsLeftMenuCollapseAndStopToggle);
    this.isCondensed = !this.isCondensed;
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle("right-bar-enabled");
  }

  routeIsActive(routePath: string) {
    let currentUrl = this.router.url;
    return currentUrl.startsWith(routePath);
    //return currentUrl.indexOf(routePath) > -1;
  }
  isRoot(): boolean {
    return this.router.url === '/' || this.router.url === '';
  }

  get hasEverUsedDragDrop(): boolean {
    return !!localStorage.getItem('cc_drag_drop_used_' + this.claims?.OrgId + '_' + this.claims?.UserId);
  }

  get isDragDropDisabledOnCurrentRoute(): boolean {
    const disabledRoutes: string[] = (this.buildDetailsService.buildDetails as any).disableDragDropRoutes || [];
    return disabledRoutes.some((route: string) => this.router.url.includes(route));
  }
}
